import { Lock } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRestrictions } from '@/app/providers';

/**
 * Banner residente: avisa que el acceso está restringido por adeudo. Se oculta solo
 * si no hay restricción de cobranza (no afecta a admin/guardia ni a residentes al día).
 *
 * Solo cubre restricciones PARCIALES (aplicadas a mano desde /restricciones).
 * Los bloqueos de cobranza son totales: ahí ProtectedRoute manda al residente
 * a /cuenta-restringida antes de renderizar el layout.
 */
export const AccessRestrictedBanner: React.FC = () => {
  const { data, loading } = useRestrictions();
  const navigate = useNavigate();

  if (loading || !data?.hasRestrictions || data.isBlacklisted) return null;

  return (
    <div className="mb-4 flex flex-col gap-3 rounded-2xl border border-red-200 bg-red-50 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-100 text-red-600">
          <Lock size={20} />
        </span>
        <div>
          <p className="text-sm font-bold text-red-700">Acceso restringido por adeudo</p>
          <p className="mt-0.5 text-sm text-red-600">
            No puedes invitar, reservar, entrar ni usar tu acceso hasta regularizar tu pago.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => navigate('/pagos')}
        className="shrink-0 cursor-pointer rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-700"
      >
        Pagar ahora
      </button>
    </div>
  );
};
